import React from 'react'
import { Box, TextField, FormControl, Grid } from '@mui/material'
import { LoadingDefault } from '@/shared/ui/loading'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave } from '@fortawesome/pro-duotone-svg-icons/faSave'
import { faEye } from '@fortawesome/pro-duotone-svg-icons/faEye'
import { faEyeSlash } from '@fortawesome/pro-duotone-svg-icons/faEyeSlash'
import image1 from '../../../../images/image1.webp'
import image2 from '../../../../images/image2.webp'
import image3 from '../../../../images/image3.webp'
import image4 from '../../../../images/image4.webp'
import image5 from '../../../../images/image5.webp'
import AppDialog from '@/shared/ui/app-dialog/AppDialog'
import { StyledButton, CompactButton } from '@/shared/ui/buttons'
import { LoginFormInput } from '@/shared/ui/input'

class UpdateUserPassword extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            password: null,
            old_password: null,
            repeat_password: null,
            showPassword: false,
            showOldPassword: false,
            showRepeatPassword: false,
            bgStyle: null,
        }

        this.handleChange = this.handleChange.bind(this)
        this.updateEnterKey = this.updateEnterKey.bind(this)
        this.update = this.update.bind(this)
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: event.target.value,
        })
    }

    updateEnterKey(event) {
        if (event.key === 'Enter') {
            this.update(event)
        }
    }

    generateDialogFooter() {
        return (
            <>
                <StyledButton
                    title={this.props.kedo.t('Update')}
                    type="submit"
                    onClick={this.update}
                >
                    {this.state.submitting ? (
                        <LoadingDefault as={'span'} />
                    ) : (
                        <FontAwesomeIcon icon={faSave} />
                    )}
                    &nbsp; {this.props.kedo.t('Update')}
                </StyledButton>
                <StyledButton color={'secondary'} onClick={this.props.onClose}>
                    {this.props.kedo.t('Cancel')}
                </StyledButton>
            </>
        )
    }

    renderModal() {
        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'sm'}
                fullWidth
                title={this.props.kedo.t('Change password')}
                onClose={this.props.onClose}
                headerClose={this.props.onClose}
                contentProps={{ dividers: true }}
                actions={this.generateDialogFooter()}
                paperSx={{
                    maxWidth: '500px',
                    width: '100%',
                }}
            >
                <>{this.renderForm()}</>
            </AppDialog>
        )
    }

    renderForm() {
        let kedo = this.props.kedo
        const currentPath = window.location.pathname
        const isProfilePage = currentPath.endsWith('/profile')

        return (
            <Box component="form" onSubmit={this.update}>
                {isProfilePage ? (
                    <FormControl fullWidth margin="normal">
                        <TextField
                            size="small"
                            autoFocus
                            error={
                                this.state.errors &&
                                this.state.errors['old_password']
                            }
                            helperText={this.state.errors?.old_password}
                            name={'old_password'}
                            placeholder={kedo.t('Old password')}
                            readOnly={this.state.loading}
                            required
                            type={this.state.showPassword ? 'text' : 'password'}
                            handleChange={this.handleChange}
                            onLoginEnterKey={this.updateEnterKey}
                            variant="outlined"
                            fullWidth
                            value={this.state.old_password}
                            onChange={this.handleChange}
                            onKeyDown={this.updateEnterKey}
                            autoComplete="off"
                            slotProps={{
                                input: {
                                    endAdornment: (
                                        <CompactButton
                                            onClick={() =>
                                                this.setState({
                                                    showOldPassword:
                                                        !this.state
                                                            .showOldPassword,
                                                })
                                            }
                                        >
                                            <FontAwesomeIcon
                                                icon={
                                                    this.state.showOldPassword
                                                        ? faEyeSlash
                                                        : faEye
                                                }
                                            />
                                        </CompactButton>
                                    ),
                                    sx: {
                                        pr: 0,
                                        height: '40px',
                                        '& .MuiInputAdornment-root svg': {
                                            width: '18px',
                                        },
                                    },
                                },
                            }}
                        />
                    </FormControl>
                ) : null}
                <br />
                <FormControl fullWidth margin="normal">
                    <TextField
                        size="small"
                        error={
                            this.state.errors && this.state.errors['password']
                        }
                        helperText={
                            this.state.errors && this.state.errors.password
                        }
                        name={'password'}
                        placeholder={kedo.t('New password')}
                        readOnly={this.state.loading}
                        required
                        type={this.state.showPassword ? 'text' : 'password'}
                        value={this.state.password}
                        onChange={this.handleChange}
                        onKeyDown={this.updateEnterKey}
                        autoComplete="off"
                        variant="outlined"
                        fullWidth
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <CompactButton
                                        onClick={() =>
                                            this.setState({
                                                showPassword:
                                                    !this.state.showPassword,
                                            })
                                        }
                                    >
                                        <FontAwesomeIcon
                                            icon={
                                                this.state.showPassword
                                                    ? faEyeSlash
                                                    : faEye
                                            }
                                        />
                                    </CompactButton>
                                ),
                                sx: {
                                    pr: 0,
                                    height: '40px',
                                    '& .MuiInputAdornment-root svg': {
                                        width: '18px',
                                    },
                                },
                            },
                        }}
                    />
                </FormControl>
                <br />
                <FormControl fullWidth margin="normal">
                    <TextField
                        size="small"
                        error={
                            this.state.errors &&
                            this.state.errors['repeat_password']
                        }
                        name={'repeat_password'}
                        placeholder={kedo.t('Repeat new password')}
                        readOnly={this.state.loading}
                        helperText={this.state.errors?.repeat_password}
                        required
                        type={this.state.showPassword ? 'text' : 'password'}
                        value={this.state.repeat_password}
                        onChange={this.handleChange}
                        onKeyDown={this.updateEnterKey}
                        autoComplete="off"
                        variant="outlined"
                        fullWidth
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <CompactButton
                                        onClick={() =>
                                            this.setState({
                                                showRepeatPassword:
                                                    !this.state
                                                        .showRepeatPassword,
                                            })
                                        }
                                    >
                                        <FontAwesomeIcon
                                            icon={
                                                this.state.showRepeatPassword
                                                    ? faEyeSlash
                                                    : faEye
                                            }
                                        />
                                    </CompactButton>
                                ),
                                sx: {
                                    pr: 0,
                                    height: '40px',
                                    '& .MuiInputAdornment-root svg': {
                                        width: '18px',
                                    },
                                },
                            },
                        }}
                    />
                </FormControl>
                <br />
            </Box>
        )
    }

    update(event) {
        event.preventDefault()
        const kedo = this.props.kedo

        this.setState({
            errors: false,
            submitting: true,
        })

        if (this.state.password !== this.state.repeat_password) {
            this.setState({
                submitting: false,
                errors: {
                    repeat_password: this.props.kedo.t(
                        'Passwords do not match'
                    ),
                },
            })
            return
        }

        let payload = {
            password: this.state.password,
            old_password: this.state.old_password,
        }

        kedo.api()
            .patch(kedo.api().getUserEndpoint() + '/change_password', payload)
            .then(() => {
                this.setState({
                    errors: false,
                    submitting: false,
                })

                this.props.onSuccess()
            })
            .catch((error) => {
                this.setState({
                    submitting: false,
                    errors: this.props.kedo
                        .api()
                        .getErrorFromApiCall(error.response),
                })
            })
    }

    componentDidMount() {
        const pictureArray = [image1, image2, image3, image4, image5]
        const randomIndex = Math.floor(Math.random() * pictureArray.length)
        const selectedPicture = pictureArray[randomIndex]

        this.setState({
            bgStyle: { backgroundImage: `url(${selectedPicture})` },
        })
    }

    render() {
        if (this.props.modal) {
            return this.renderModal()
        }

        return (
            <Grid
                size={{ xs: 12, md: 6 }}
                style={this.state.bgStyle}
                className={'login outerContainer fullHeight'}
            >
                <Grid container justifyContent="center">
                    <Grid
                        size={{ xs: 10, md: 8, lg: 4 }}
                        className="mainContainer"
                    >
                        <h1>{this.props.kedo.t('change_password_title')}</h1>
                        <p>{this.props.kedo.t('change_password_text')}</p>
                        {this.renderForm()}
                        <StyledButton
                            title={this.props.kedo.t('Update')}
                            type="submit"
                            onClick={this.update}
                        >
                            {this.state.submitting ? (
                                <LoadingDefault as={'span'} />
                            ) : null}{' '}
                            {this.props.kedo.t('Update')}
                        </StyledButton>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

export default UpdateUserPassword
